import React from "react";

function HomeHeader() {
  return (
    <div className="index">

      <section id="header">

        <div className="header-content mt_84">
          <img
            alt="demonstration1"
            id="header-logo"
            src={"assets/images/valaroklogo.webp"}
          />
          <p className="mt_84">
              Valarok represents a vision,
              <br />
              A new world to explore,
              <br />
              An ancient story shaped in our future that revolutionizes the present.
              <br />
              A unique opportunity in Web3,
              <br />
              With an NFT collection based on 3 different races,
              <br />
              Ensuring access to a variety of content and resources.
              <br />
              An extraordinary entertainment opportunity and the chance to be part of something grand.
              <br />
              This marks the beginning of a reality destined to endure.
              <br /><br />
              WELCOME TO VALAROK
          </p>

        </div>
      </section>
    </div>
  )
}

export default HomeHeader;
